import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import msbHome from '../views/msbHome.vue'


Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'msbHome',
  //   meta: {
  //     title: '平塘网上营业厅',
  //   },
  //   component: msbHome
  // },
  // {
  //   path: '/',
  //   name: 'outlets',
  //   meta: {
  //     title: '网点导航',
  //   },
  //   component: () => import('../views/outlets/index.vue')
  // },
  {
    path: '/',
    name: 'Home',
    meta: {
      title: '平塘网上营业厅',
    },
    component: Home
  },
  {
    path: '/Home',
    name: 'Home',
    meta: {
      title: '平塘网上营业厅',
    },
    component: Home
  },
  {
    path: '/msbHome',
    name: 'msbHome',
    meta: {
      title: '平塘网上营业厅',
    },
    component: msbHome
  },
  {
    path: '/ssoLogin',
    name: 'ssoLogin',
    meta: {
      title: '',
    },
    component: () => import('../views/ssoLogin/index')
  },
  {
    path: '/applicateIndex',
    name: 'applicateIndex',
    meta: {
      title: '个人客户接水',
    },
    component: () => import('../views/waterApplication/applicateIndex.vue')
  },
  {
    path: '/waterServer',
    name: 'waterServer',
    meta: {
      title: '表单',
    },
    component: () => import('../views/waterApplication')
  },
  {
    path: '/waterBill',
    name: 'waterBill',
    meta: {
      title: '水费清单',
    },
    component: () => import('../views/waterBill')
  },
  {
    path: '/details',
    name: 'details',
    meta: {
      title: '详情',
    },
    component: () => import('../views/details')
  },
  {
    path: '/waterConsumptionAnalysis',
    name: 'waterConsumptionAnalysis',
    meta: {
      title: '用水量分析',
    },
    component: () => import('../views/waterConsumptionAnalysis')
  },
  {
    path: '/information',
    name: 'Information',
    meta: {
      title: '信息公告',
    },
    component: () => import('../views/information')
  },
  {
    path: '/info',
    name: 'info',
    meta: {
      title: '信息公告',
    },
    component: () => import('../views/information/info')
  },
  {
    path: '/invoice',
    name: 'Invoice',
    meta: {
      title: '电子发票',
    },
    component: () => import('../views/invoice/index.vue')
  },
  {
    path: '/waterFeePayment',
    name: 'WaterFeePayment',
    meta: {
      title: '水费缴纳',
    },
    component: () => import('../views/waterFeePayment')
  },
  {
    path: '/confirm',
    name: 'confirm',
    meta: {
      title: '水费缴纳',
    },
    component: () => import('../views/waterFeePayment/confirm')
  },
  {
    path: '/pay',
    name: 'pay',
    meta: {
      title: '水费缴纳',
    },
    component: () => import('../views/waterFeePayment/pay')
  },
  {
    path: '/waterFeePayment',
    name: 'WaterFeePayment',
    meta: {
      title: '水费缴纳',
    },
    component: () => import('../views/waterFeePayment')
  },
  {
    path: '/progressQuery',
    name: 'progressQuery',
    meta: {
      title: '办件进度查询',
    },
    component: () => import('../views/progressQuery/index.vue')
  },
  {
    path: '/householdList',
    name: 'householdList',
    meta: {
      title: '户号绑定',
    },
    component: () => import('../views/householdBinding/householdList.vue')
  },
  {
    path: '/householdBinding',
    name: 'householdBinding',
    meta: {
      title: '户号绑定',
    },
    component: () => import('../views/householdBinding/index.vue')
  },
  {
    path: '/houseSearch',
    name: 'houseSearch',
    meta: {
      title: '户号查询',
    },
    component: () => import('../views/householdBinding/houseSearch.vue')
  },
  // {
  //   path: '/bindList',
  //   name: 'bindList',
  //   meta: {
  //     title: '户号绑定',
  //   },
  //   component: () => import('../views/userNumberBinding/bindList.vue')
  // },
  // {
  //   path: '/userNumberBinding',
  //   name: 'userNumberBinding',
  //   meta: {
  //     title: '户号绑定',
  //   },
  //   component: () => import('../views/userNumberBinding/index.vue')
  // },
// --
  {
    path: '/businessOutlets',
    name: 'businessOutlets',
    meta: {
      title: '营业网点',
    },
    component: () => import('../views/businessOutlets/index.vue')
  },
  // 跟聊城类似的
  // {
  //   path: '/serviceHotline',
  //   name: 'serviceHotline',
  //   meta: {
  //     title: '网点导航',
  //   },
  //   component: () => import('../views/serviceHotline/index.vue')
  // },
  {
    path: '/outlets',
    name: 'outlets',
    meta: {
      title: '营业网点',
    },
    component: () => import('../views/outlets/index.vue')
  },
  {
    path: '/outletsDetail',
    name: 'outletsDetail',
    meta: {
      title: '营业网点',
    },
    component: () => import('../views/outlets/outletsDetail.vue')
  },
  {
    path: '/iserSurveyHomepage',
    name: 'iserSurveyHomepage',
    meta: {
      title: '供水用户调查',
    },
    component: () => import('../views/iserSurveyHomepage/index.vue')
  },
  {
    path: '/userSurveyDetails',
    name: 'userSurveyDetails', 
    meta: {
      title: '供水用户调查',
    },
    component: () => import('../views/userSurveyDetails/index.vue') 
  },
  {
    path: '/proposal', 
    name: 'proposal', 
    meta: {
      title: '投诉建议',
    },
    component: () => import('../views/proposal/index.vue') 
  },
  {
    path: '/violationReport', 
    name: 'violationReport', 
    meta: {
      title: '违章举报',
    },
    component: () => import('../views/violationReport/index.vue') 
  },
  {
    path: '/reportForRepair', 
    name: 'reportForRepair', 
    meta: {
      title: '报修报漏',
    },
    component: () => import('../views/reportForRepair/index.vue') 
  },
  {
    // 业务指南/ 停水公告 / 用水常识 / 服务公告 / 宣传报道
    path: '/commonFunctions', 
    name: 'commonFunctions', 
    meta: {
      title: '常用功能',
    },
    component: () => import('../views/commonFunctions/index.vue')
  },
  {
    path: '/commonFunctionsDetails', 
    name: 'commonFunctionsDetails', 
    meta: {
      title: '常用功能',
    },
    component: () => import('../views/commonFunctionsDetails/index.vue')
  },
  {
    path: '/serviceCommitment', 
    name: 'serviceCommitment', 
    meta: {
      title: '服务承诺',
    },
    component: () => import('../views/serviceCommitment/index.vue') 
  },
  {
    path: '/waterPriceinformation', 
    name: 'waterPriceinformation', 
    meta: {
      title: '现行水价',
    },
    component: () => import('../views/waterPriceinformation/index.vue') 
  },
  {
    path: '/meterReaderQuery', 
    name: 'meterReaderQuery', 
    meta: {
      title: '抄表员查询',
    },
    component: () => import('../views/meterReaderQuery/index.vue') 
  },
  {
    path: '/meterReaderInformation', 
    name: 'meterReaderInformation', 
    meta: {
      title: '抄表员信息',
    },
    component: () => import('../views/meterReaderInformation/index.vue') 
  },
  {
    path: '/businessProcessingProgress', 
    name: 'businessProcessingProgress', 
    meta: {
      title: '业务办理进度',
    },
    component: () => import('../views/businessProcessingProgress/index.vue') 
  },
  {
    path: '/preview', 
    name: 'preview', 
    meta: {
      title: '图片',
    },
    component: () => import('../views/preview.vue') 
  },
  {
    path: '/handlingEvaluation', 
    name: 'handlingEvaluation', 
    meta: {
      title: '办件评价',
    },
    component: () => import('../views/handlingEvaluation/index.vue') 
  },
  // 为了应付领导检查暂时加的
  {
    path: '/evaluate', 
    name: 'evaluate', 
    meta: {
      title: '业务评价',
    },
    component: () => import('../views/evaluate/index.vue') 
  },{
    path: '/filemenu', 
    name: 'filemenu', 
    meta: {
      title: '信息公告',
    },
    component: () => import('../views/filemenu/index.vue') 
  },{
    path: '/emenuformation', 
    name: 'emenuformation', 
    meta: {
      title: '信息公告',
    },
    component: () => import('../views/filemenu/emenuformation.vue') 
  },
]
const router = new VueRouter({
  routes
})
export default router
